import { Typography, useSessionStorage } from "@pmag/ui-components";
import { WishlistButton } from "@src/components/wishlistButton/WishlistButton";
import { useAttributeConfig } from "@src/hooks/useAttributeConfig";
import { useGlobalState } from "@src/hooks/useGlobalState";
import {
    defaultSessionFilterState,
    sessionFilterSchema,
    type SessionFilterState,
} from "@src/pages/compatibilityCheck/components/usageList/UsageListFormSchema";
import { categoryTabSchema } from "@src/pages/componentGroupOverview/ComponentGroupOverviewPage";
import { ComponentGroupOverviewCategoryTabs } from "@src/pages/componentGroupOverview/ComponentGroupOverviewPage.utils";
import { BrandSelection } from "@src/pages/landingPage/components/brandSelection/BrandSelection";
import { CategorySelection } from "@src/pages/landingPage/components/categorySelection/CategorySelection";
import { CompatibilityCheckTeaser } from "@src/pages/landingPage/components/compatibilityCheckTeaser/CompatibilityCheckTeaser";
import { RecentlyViewed } from "@src/pages/landingPage/components/recentlyViewed/RecentlyViewed";
import { SearchContainer } from "@src/pages/landingPage/components/searchContainer/SearchContainer";
import * as React from "react";
import { FormattedMessage } from "react-intl";

import { ContainerBox, LeftBox, TopBox } from "./LandingPage.styles";

export const dataTestId = {
    container: "sparePartsFinder.landingPage.container",
};

export const LandingPage: React.FunctionComponent = () => {
    const { brandId } = useGlobalState();
    const { showCompatibilityCheck } = useAttributeConfig();

    const [appliedFilter, setAppliedFilter] = useSessionStorage<SessionFilterState>("filter", defaultSessionFilterState, sessionFilterSchema);
    const [categoryTab, setCategoryTab] = useSessionStorage<ComponentGroupOverviewCategoryTabs>(
        "sparePartsFinderOverviewCategoryTab",
        ComponentGroupOverviewCategoryTabs.Frame,
        categoryTabSchema,
    );

    // reset applied usage list filter and reset component group tab
    React.useEffect(() => {
        if (categoryTab !== ComponentGroupOverviewCategoryTabs.Frame) setCategoryTab(ComponentGroupOverviewCategoryTabs.Frame);
        if (appliedFilter.articleNumber || appliedFilter.articleDescription) setAppliedFilter(defaultSessionFilterState);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <TopBox>
                <Typography variant="body-short-02">
                    <FormattedMessage id="sparePartsFinder.landingPage.title" defaultMessage="Select your model and find fitting spare parts." />
                </Typography>

                <WishlistButton />
            </TopBox>

            <ContainerBox data-testid={dataTestId.container}>
                <LeftBox>
                    <SearchContainer />

                    {brandId ? <CategorySelection /> : <BrandSelection />}

                    <RecentlyViewed />
                </LeftBox>

                {showCompatibilityCheck && <CompatibilityCheckTeaser />}
            </ContainerBox>
        </>
    );
};
